import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { MapPin } from "lucide-react";
import { Control } from "react-hook-form";
import { FormData } from "./schema";

import { GetStationsResponse } from "api/vendor/getStations";

interface LocationCardProps {
  control: Control<FormData>;
  fieldName: "selectedWarehouse" | "selectedDestination";
  title: string;
  description: string;
  options:
    | GetStationsResponse["pickUpStations"]
    | GetStationsResponse["dropOffStations"];
  selectedData:
    | GetStationsResponse["dropOffStations"][0]
    | GetStationsResponse["pickUpStations"][0]
    | undefined;
  colorScheme: "blue" | "green";
}

export function LocationCard({
  control,
  fieldName,
  title,
  description,
  options,
  selectedData,
  colorScheme,
}: LocationCardProps) {
  const bgColor =
    colorScheme === "blue"
      ? "bg-blue-50 border-blue-200"
      : "bg-green-50 border-green-200";
  const textColor = colorScheme === "blue" ? "text-blue-900" : "text-green-900";
  const subTextColor =
    colorScheme === "blue" ? "text-blue-700" : "text-green-700";

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-lg">
          <MapPin className="h-4 w-4" />
          {title}
        </CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <FormField
          control={control}
          name={fieldName}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{title} *</FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue
                      placeholder={`Select a ${title.toLowerCase()}`}
                    />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {options.map((warehouse) => (
                    <SelectItem key={warehouse.id} value={warehouse.id}>
                      {warehouse.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />

        {selectedData && (
          <div className={`p-3 rounded-lg border ${bgColor}`}>
            <h4 className={`font-medium ${textColor}`}>{selectedData.name}</h4>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
